import React from "react";
import { useTranslation } from "react-i18next";

import {
    Card,
    SectionHeader,
    SectionTitle,
    ToggleContainer,
    ToggleLabel,
    Toggle,
} from "./styled";

type CustomMessageCardProps = {
    mainColor: string;
    customMessageEnabled: boolean;
    onToggle: () => void;
};

export function CustomMessageCard({
    mainColor,
    customMessageEnabled,
    onToggle,
}: CustomMessageCardProps): JSX.Element {
    const { t } = useTranslation();

    return (
        <Card data-testid="scan-to-server-call-custom-message-card">
            <SectionHeader>
                <SectionTitle>{t("Custom message")}</SectionTitle>
                <ToggleContainer>
                    <ToggleLabel>
                        {customMessageEnabled ? t("Active") : t("Disabled")}
                    </ToggleLabel>
                    <Toggle
                        data-testid="scan-to-server-call-custom-message-toggle"
                        isActive={customMessageEnabled}
                        mainColor={mainColor}
                        onClick={onToggle}
                        aria-label={t("Enable custom message")}
                    />
                </ToggleContainer>
            </SectionHeader>

            {customMessageEnabled && (
                <p style={{ fontSize: "13px", color: "#666", margin: 0 }}>
                    {t("Enable custom message")}
                </p>
            )}
        </Card>
    );
}
